// extracted by mini-css-extract-plugin
export var actionButton = "_h6-t";
export var buttonContainer = "_h6-0";
export var buttonContainer2 = "_h6-1";
export var buttonSection = "_h6-2";
export var details = "_h6-3";
export var dropdownItem = "_h6-5";
export var dropdownItemsContainer = "_h6-4";
export var fileInput = "_h6-r";
export var headerButton = "_h6-6";
export var icon = "_h6-7";
export var input = "_h6-8";
export var macroListItem = "_h6-9";
export var mainContent = "_h6-a";
export var microText = "_h6-b";
export var modal = "_h6-w";
export var optionsButton = "_h6-c";
export var paperclip = "_h6-s";
export var pillContent = "_h6-d";
export var preview = "_h6-e";
export var preview2 = "_h6-f";
export var quillEditor = "_h6-q";
export var selectedMacro = "_h6-g";
export var sidebar = "_h6-h";
export var sidebarHeader = "_h6-j";
export var sidebarList = "_h6-i";
export var sidebarListItem = "_h6-k";
export var sidebarSearch = "_h6-l";
export var snoozeDurationWrapper = "_h6-v";
export var statusPillContainer = "_h6-m";
export var tagsContainer = "_h6-n";
export var unselectedMacro = "_h6-o";
export var variable = "_h6-u";
export var wrapper = "_h6-p";